export default {"src":"/_next/static/media/garden-header.5aa15f92.svg","height":71,"width":708,"blurWidth":0,"blurHeight":0};